import { z } from "zod";

import type { ChildProfile } from "../contracts";
import {
  boundedTextSchema,
  entityIdSchema,
  hasUniqueValues,
  kebabCaseIdentifierSchema,
  timestampSchema
} from "./common";

export const MAX_CHILD_PROFILES = 3;

const parentPinHashSchema = z
  .string()
  .min(8)
  .max(512)
  .refine((value) => value === value.trim(), {
    message: "Leading or trailing whitespace is not allowed"
  })
  .refine((value) => !/^\d{4}$/.test(value), {
    message: "A raw parent PIN must never be stored"
  });

export const childProfileSchema = z.strictObject({
  id: entityIdSchema,
  nickname: boundedTextSchema(20),
  avatarId: kebabCaseIdentifierSchema,
  createdAt: timestampSchema,
  parentPinHash: parentPinHashSchema.optional()
}) satisfies z.ZodType<ChildProfile>;

export const childProfilesSchema = z
  .array(childProfileSchema)
  .max(MAX_CHILD_PROFILES)
  .refine((profiles) => hasUniqueValues(profiles.map(({ id }) => id)), {
    message: "Profile identifiers must be unique"
  });
